import {Grid, GridItem, Heading, Text, useColorModeValue,} from '@chakra-ui/react'
import Head from 'next/head'

// import Category from '../components/Category'
import {CategoryContainer, CategoryHeader, CategoryItem, CategoryItemDivider} from '../../components/Category'
import useDraftShoppingCart from "../../components/hooks/useDraftShoppingCart";
import MobileBottomBar from '../../components/MobileBar'
import {Footer} from '../../components/sections/Footer'
import {Hero} from '../../components/sections/Hero'
import PageWrapper from '../../components/sections/PageWrapper'
import {CartContainer, CartItem, CartItemDivider, CartPriceAndCheckout} from '../../components/ShoppingCartDetails'
import MyError from "../_error";
import {getEventData} from '../api/events/[slug]'

const getNormalizedUrl = (url) => {
    const {origin, pathname} = new URL(url)
    return `${origin}/cdn-cgi/image/fit=contain${pathname}`
}

export default function EventPage({data, slug, error, statusCode}) {
    const text = useColorModeValue('light', 'dark')
    const {draftShoppingCartItems} = useDraftShoppingCart()

    if (error) {
        return <MyError statusCode={statusCode} err={error}/>
    }

    const title = `${data.event_name} at ${data.provider_name}`
    return (
        <>
            <Head>
                <title>{title}</title>
                <meta name="description" content={data.event_description}/>
                <link rel="icon" href="/favicon.svg"/>

                <meta property="og:type" content="website"/>
                <meta property="og:site_name" content="Boutique Mate Events"/>
                <meta property="og:title" content={title}/>
                <meta property="og:description" content={data.event_description}/>
                <meta property="og:image" content={data.hero_image_url}/>
                <meta name="twitter:card" content="summary_large_image"/>
                <meta property="twitter:domain" content="development.events.boutiquemate.com"/>
                <meta name="twitter:title" content={title}/>
                <meta name="twitter:description" content={data.event_description}/>
                <meta name="twitter:image" content={data.hero_image_url}/>
            </Head>
            <Hero
                eventName={data.event_name}
                eventBGImage={data.hero_image_url}
                eventPosterImage={data.poster_image_url}
                eventCategories={data.event_categories}
                providerName={data.provider_name}
                eventSubtitle={data.event_subtitle}
                providerAddress={data.provider_address}
            />
            <PageWrapper>
                <Grid
                    templateColumns='repeat(8, 1fr)'
                    gap={6}
                    // pb='4.5rem'
                >
                    <GridItem p={4} colSpan={{base: '8', sm: '8', md: '6'}} w='100%'>
                        {/* Categories */}
                        {
                            data.event_categories.sort((a, b) => a.category_name.localeCompare(b.category_name)).map((category, index) => (
                                <CategoryContainer key={category.category_name}>
                                    <CategoryHeader categoryName={category.category_name}/>
                                    {category.category_items.map((item) => (
                                        <>
                                            <CategoryItem
                                                key={item.schema_info.id}
                                                categoryItem={item}
                                            />
                                            <CategoryItemDivider/>
                                        </>
                                    ))}
                                </CategoryContainer>
                            ))
                        }
                        {/* Add-ons    */}
                        {data.addons && data.addons.length > 0 && (
                            <CategoryContainer key='addons-category-container'>
                                <CategoryHeader categoryName="Add-Ons"/>
                                {data.addons[0].category_items.map((item, index) => (
                                    <>
                                        <CategoryItem
                                            key={item.schema_info.id}
                                            categoryItem={item}
                                            isAddon
                                        />
                                        <CategoryItemDivider/>
                                    </>
                                ))}
                            </CategoryContainer>
                        )}
                        {/* Event Description */}
                        <Heading pt={6} pb={4} fontSize='2xl'> About this event </Heading>
                        <Text whiteSpace="pre-line">
                            {data.event_description}
                        </Text>
                        {/* Event Terms & Conditions */}
                        <Heading pt={6} pb={4} fontSize='2xl'> Terms & Conditions </Heading>
                        <Text whiteSpace="pre-line">
                            {data.event_terms_and_conditions}
                        </Text>
                    </GridItem>
                    <GridItem pt={4} colSpan={{md: '2'}} display={{base: 'none', md: 'block'}} w='100%'>
                        <CartContainer>
                            {draftShoppingCartItems.map((item, index) => (
                                <>
                                    <CartItem
                                        cartItem={item}
                                        key={`${item.categoryItemName}-${item.categoryItemPrice}`}
                                    />
                                    <CartItemDivider/>
                                </>
                            ))}
                            <CartPriceAndCheckout/>
                        </CartContainer>
                    </GridItem>
                </Grid>
                <MobileBottomBar/>
            </PageWrapper>
            <Footer
                providerName={data.provider_name}
                providerEmail={data.provider_email}
                providerPhoneNumber={data.provider_phone_number}
                providerAddress={data.provider_address}
            />
        </>
    )
}

export async function getServerSideProps(context) {
    const {slug} = context.params
    // Fetch data from external API
    try {
        const data = await getEventData(slug)
        if (data.non_field_errors && data.non_field_errors[0] === 'Not found.') {
            return {
                notFound: true
            };
        }
        // Pass data to the page via props
        return {props: {data}}
    } catch (error) {
        return {
            props: {
                error: true,
                statusCode: 500
            }
        }
    }

}